<template>
<div id="basic-non-sticky-notification-packet-success" class="toastify-content hidden flex flex-col sm:flex-row">
    <div class="flex items-center justify-around">
        <CheckCircleIcon class="w-6 h-6 text-theme-9 mx-auto" />
        <div class="font-medium text-black">{{ pagedata.message }}</div>
    </div>
</div>
<div id="basic-non-sticky-notification-packet-error" class="toastify-content hidden flex flex-col sm:flex-row">
    <div class="flex items-center justify-around">
        <CheckCircleIcon class="w-6 h-6 text-theme-6 mx-auto" />
        <div class="font-medium text-black">{{ pagedata.error }}</div>
    </div>
</div>
<div>
    <!-- BEGIN: Data List -->
    <div class="intro-y box overflow-auto p-3 my-5" v-if="pagedata.packets.length > 0">

        <table class="table w-full">
            <thead>
                <tr>
                    <th class="">
                        <div class="flex items-center justify-end">
                            <!-- <h2 class="intro-y text-lg font-medium mr-5">All Packets of Lot No :  <span class="ml-2 text-primary-1">{{ pagedata.lat_no }}</span></h2> -->
                            <button type="button" class="btn btn-primary btn-sm shadow-md mx-2" @click="print_multi_stone(pagedata.packets)">
                                <PrinterIcon class="w-4 h-4" /></button>
                            <a href="javascript:;" @click="pagedata.packets = []" class="btn btn-danger btn-sm mx-2">
                                <XIcon class="w-4 h-4" /></a>
                        </div>
                    </th>
                    <th class="">Status</th>
                    <th class="">Pkt No</th>
                    <th class="">Stock No</th>
                    <th class="">Weight</th>
                    <th class="">Exp. Wt</th>
                    <th class="">Shape</th>
                    <th class="">Color</th>
                    <th class="">Purity</th>
                    <th class="">Cut</th>
                    <th class="">Polish</th>
                    <th class="">Symm</th>
                    <th class="">Length</th>
                    <th class="">Width</th>
                    <th class="">Height</th>
                    <th class="">Comment</th>
                    <th class="">Per/Ct</th>
                    <th class="">Total Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(packet, index) in pagedata.packets" :key="index" class="border hover:bg-gray-200 p-0 cursor-pointer">
                    <td class="py-2 font-medium text-center" v-if="[1,2,8].includes(user_details.user_role)">
                        <div class="flex justify-start items-center p-0 m-0">
                          <div>
                            <a class="flex items-center text-theme-1" href="javascript:;" title="Add Comment" data-toggle="modal" @click="AddStoneDetails(packet)" data-target="#add-packet-part-modal">
                                <FileTextIcon class="w-5 h-5 mr-1" />
                            </a>
                          </div>
                          <div>
                            <button class="text-theme-1 mr-3" v-if="user_details.user_role != 3" @click="print_single_stone(packet)">
                                <PrinterIcon class="w-5 h-5" />
                            </button>
                          </div>
                          <div>
                            <a class="flex items-center text-theme-6 mr-3" v-if="(packet.status == 1 || packet.status == 0)" href="javascript:;" title="Reject" @click="DeletePacket(packet.id)">
                                <Trash2Icon class="w-5 h-5 mr-1" />
                            </a>
                          </div>
                          <div>
                              <a class="flex items-center text-theme-9" v-if="packet.status == 1 && packet.assineaccess == true && packet.manager_id == user_details.account_id" href="javascript:;" title="Assigh Process" data-toggle="modal" @click="SinglePacketAssign(packet.id, packet.number, packet.type)" data-target="#single-process-modal">
                                  <ChevronsRightIcon class="w-6 h-6 mr-1" />
                              </a>
                          </div>
                          <div>
                              <a class="flex items-center text-theme-1" v-if="packet.status == 0 && packet.assineaccess == true" href="javascript:;" title="Assign Process" @click="AddToStock(packet.id)">
                                  A
                              </a>
                          </div>
                      </div>
                    </td>
                    <td class="whitespace-nowrap">
                        <div v-if="packet.status == 2">
                            <p class="text-primary-1">In Process</p>
                        </div>
                        <div v-else-if="packet.status == 1">
                            <p class="text-primary-8">Active</p>
                        </div>
                        <div v-else-if="packet.status == 0">
                            <p class="text-primary-6">Hold</p>
                        </div>
                        <div v-else-if="packet.status == 3">
                            <p class="text-primary-3">Cancelled</p>
                        </div>
                        <div v-else-if="packet.status == 6">
                            <p class="text-primary-4">Delivered</p>
                        </div>
                        <div v-else-if="packet.status == 4">
                            <p class="text-primary-4">Blocked</p>
                        </div>
                        <div v-else-if="packet.status == 5">
                            <p class="text-primary-4">Out Word</p>
                        </div>
                        <div v-else-if="packet.status == 7">
                            <p class="text-primary-4">Merged</p>
                        </div>
                    </td>
                    <td class="whitespace-nowrap">{{ packet.number }}</td>
                    <td class="whitespace-nowrap">{{ packet.vepari_no ? packet.vepari_no : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.weight ? packet.weight : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.cr_polish_weight ? packet.cr_polish_weight : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.shape_name ? packet.shape_name : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.color_name ? packet.color_name : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.purity_name ? packet.purity_name : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.cut_name ? packet.cut_name : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.polish_name ? packet.polish_name : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.symmetry_name ? packet.symmetry_name : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.length ? $h.myFloat(packet.length ? packet.length : 0) : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.width ? $h.myFloat(packet.width ? packet.width : 0) : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.height ? $h.myFloat(packet.height ? packet.height : 0) : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.comment ? packet.comment : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.owner_per_ct ? packet.owner_per_ct : '-' }}</td>
                    <td class="whitespace-nowrap">{{ packet.owner_value ? packet.owner_value : '-' }}</td>
                    
                </tr>
            </tbody>
        </table>
    </div>
    <!-- END: Data List -->
    <!-- BEGIN: Data List -->
    <div class="intro-y box p-5">
        <div class="flex flex-wrap items-center justify-between">
            <h2 class="text-lg font-bold">Purchase Detail</h2>
            <div class="grid grid-cols-12 gap-x-2 w-full">
                <div class="col-span-6 md:col-span-3 xl:col-span-2">
                    <div>
                        <!-- <label for="update-profile-form-6" class="form-label py-1">Kapan No</label> -->
                        <input id="tabulator-html-filter-value" v-model="filters.kapan_no" type="text" class="form-control 2xl:w-full mt-2 sm:mt-0" placeholder="Kapan No" />
                    </div>
                </div>
                <div class="col-span-6 md:col-span-3 xl:col-span-2">
                    <select class="form-select" v-model="filters.stone_id" @change="initTabulator" aria-label="Default select example">
                        <option value="0">Select Stone</option>
                        <option v-for="(stone,index) in pagedata.stones" :key="index" :value="stone.id">{{ stone.stone_name }}</option>
                    </select>
                </div>
                <div class="col-span-6 md:col-span-3 xl:col-span-2" v-if="user_details.user_role != 3">
                    <select class="form-select" v-model="filters.party" @change="initTabulator" aria-label="Default select example">
                        <option value="0">Select Party</option>
                        <option v-for="(party,index) in pagedata.parties" :key="party.id" :value="party.id">{{ party.first_name + ' '+ party.last_name }}({{ party.short_name }})</option>
                    </select>
                </div>
                <div class="col-span-6 md:col-span-3 xl:col-span-2">
                    <select class="form-select" v-model="filters.type" @change="initTabulator" aria-label="Default select example">
                        <option value="select">Select Status</option>
                        <option value="0">Hold</option>
                        <option value="2">Processing</option>
                        <option value="1">Active</option>
                        <option value="3">Rejected</option>
                        <option value="4">Delivered</option>
                    </select>
                </div>
                <div class="col-span-2 md:col-span-2 xl:col-span-1">
                    <div class="flex">

                        <button id="tabulator-html-filter-reset" type="button" class="btn btn-secondary w-full mt-2 sm:mt-0 sm:ml-2" @click="onResetFilter">
                            Reset
                        </button>
                    </div>
                </div>
                <div class="col-span-2 md:col-span-2 xl:col-span-1">
                    <div class="flex">

                        <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full ml-2" tabindex="5" @click="initTabulator()">
                            Go
                        </button>
                    </div>
                </div>
                <!-- <div class="w-48 relative text-gray-700 dark:text-gray-300">
             <select
                 class="form-select"
                 v-model="filters.purchase_type"
                 @change="initTabulator"
                 aria-label="Purchase Type"
               >
                 <option value="0">Select Type</option>
                 <option value="makeable">Makeable</option>
                 <option value="rough">Rough</option>
                 <option value="video">Video</option>
               </select>
           </div> -->
                <!-- <router-link :to="{ name: 'purchase-create' }" class="btn btn-primary shadow-md ml-3">Add Purchase</router-link> -->
            </div>
        </div>
        <div class="overflow-x-auto scrollbar-hidden">
            <div id="tabulator" ref="tableRef" class="mt-5 table-report table-report--tabulator"></div>
        </div>
    </div>
    <!-- END: Data List -->
    <div id="superlarge-modal-size-preview2" class="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <a data-dismiss="modal" href="javascript:;">
                    <XIcon class="w-8 h-8 text-gray-500" />
                </a>
                <div class="modal-body p-10">
                    <!-- <div id="vertical-form"> -->
                    <div class="flex flex-col justify-between mt-5">
                        <!-- BEGIN: Data List -->
                        <div class="intro-y overflow-auto">
                            <div class="flex items-center">
                                <h2 class="intro-y text-lg font-medium mr-5">All Packets of Lot No : <span class="ml-2 text-primary-1">{{ pagedata.lat_no }}</span></h2>
                            </div>
                        </div>
                        <div class="m-auto mt-3">
                            <div class="mt-3">
                                <label for="update-profile-form-6" class="form-label">Transaction Type</label>
                                <TomSelect v-model="process.transaction_type" @change="validateManagerId(process.manager_id)" :options="{
                              placeholder: 'Select Transaction Type'
                            }" class="w-60">
                                    <option value="0">Manager Transfer</option>
                                    <option value="1">Process Assign</option>
                                </TomSelect>
                            </div>
                            <div class="mt-3">
                                <label for="update-profile-form-6" class="form-label">Select Manager</label>
                                <TomSelect v-model="process.manager_id" @change="validateManagerId(process.manager_id)" :options="{
                              placeholder: 'Select Manager'
                            }" class="w-60">
                                    <option value="0">Select Manager</option>
                                    <option v-for="(manager,ind) in pagedata.managers" :key="ind" :value="manager.id">{{ manager.first_name + ' ' + manager.last_name }}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.manager_id">{{ pagedata.errors.manager_id[0] }}</span>
                            </div>
                            <div class="mt-3" v-if="process.manager_id != '0' && process.transaction_type == '1'">
                                <label for="update-profile-form-6" class="form-label">Select Process</label>
                                <TomSelect v-model="process.process_id" @change="getMultiplePktEmployees(process.process_id)" :options="{
                              placeholder: 'Select Process'
                            }" class="w-60">
                                    <option value="0">Select Process</option>
                                    <option v-for="(process,ind) in pagedata.multipleprocess" :key="ind" :value="process.id">{{ process.process_name }}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.process_id">{{ pagedata.errors.process_id[0] }}</span>

                            </div>
                            <div class="flex items-center mt-3" v-if="process.process_id != '0' && process.transaction_type == '1'">
                                <div class="form-check">
                                    <input class="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-1 ml-3 cursor-pointer" value="0" type="radio" name="singleinternal" id="singleinternal" v-model="process.eternals">
                                    <label class="form-check-label inline-block text-black text-lg" for="singleinternal">
                                        Internal
                                    </label>
                                </div>
                                <div class="form-check ml-6">
                                    <input class="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-1 ml-3 cursor-pointer" value="1" type="radio" name="singleexternal" id="singleexternal" v-model="process.eternals">
                                    <label class="form-check-label inline-block text-black text-lg" for="singleexternal">
                                        Enternal
                                    </label>
                                </div>
                            </div>
                            <div class="mt-3" v-if="process.eternals == '0' && process.process_id != '0' && process.transaction_type == '1'">
                                <label for="update-profile-form-6" class="form-label">Select Employee</label>
                                <TomSelect v-model="process.employee_id" :options="{
                                placeholder: 'Select Employee'
                              }" class="w-60">
                                    <option value="0">Select Employee</option>
                                    <option v-for="(emp,ind) in pagedata.multipleemployees" :key="ind" :value="emp.id">{{ emp.first_name + ' ' + emp.last_name}}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.employee_id">{{ pagedata.errors.employee[0] }}</span>
                            </div>
                            <div class="mt-3" v-else-if="process.eternals == '1' && process.process_id != '0' && process.transaction_type == '1'">
                                <label for="update-profile-form-6" class="form-label">Select Party</label>
                                <TomSelect v-model="process.party_id" :options="{
                            placeholder: 'Select Party'
                          }" class="w-60">
                                    <option value="0">Select Party</option>
                                    <option v-for="(party,ind) in pagedata.multipleparties" :key="ind" :value="party.id">{{ party.firm_name }}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.party_id">{{ pagedata.errors.party_id[0] }}</span>
                            </div>
                        </div>
                        <button type="button" @click="AssignProcess" :disabled="pagedata.submit" class="btn btn-primary w-24 m-auto mt-3">Submit
                            <LoadingIcon v-if="pagedata.submit" icon="oval" color="white" class="w-4 h-4 ml-2" /></button>
                        <!-- END: Data List -->
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- BEGIN: Single Process Assign Modal -->
    <div id="single-process-modal" class="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <a data-dismiss="modal" href="javascript:;">
                    <XIcon class="w-8 h-8 text-gray-500" />
                </a>
                <div class="modal-body p-10">
                    <div class="flex flex-col justify-between mt-5">
                        <!-- BEGIN: Data List -->
                        <div class="intro-y overflow-auto">
                            <div class="flex items-center">
                                <h2 class="intro-y text-lg font-medium mr-5">Packet No : <span class="ml-2 text-primary-1">{{ singleProcess.number }}</span></h2>
                            </div>
                        </div>
                        <div class="m-auto mt-3">
                            <div class="mt-3">
                                <label for="update-profile-form-6" class="form-label">Transaction Type</label>
                                <TomSelect v-model="singleProcess.transaction_type" @change="singlevalidateManagerId(singleProcess.manager_id)" :options="{
                          placeholder: 'Select Transaction Type'
                        }" class="w-60">
                                    <option value="0">Manager Transfer</option>
                                    <option value="1">Process Assign</option>
                                </TomSelect>
                            </div>
                            <div class="mt-3">
                                <label for="update-profile-form-6" class="form-label">Select Manager</label>
                                <TomSelect v-model="singleProcess.manager_id" @change="singlevalidateManagerId(singleProcess.manager_id)" :options="{
                          placeholder: 'Select Manager'
                        }" class="w-60">
                                    <option value="0">Select Manager</option>
                                    <option v-for="(manager,ind) in pagedata.managers" :key="ind" :value="manager.id">{{ manager.first_name + ' ' + manager.last_name }}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.manager_id">{{ pagedata.errors.manager_id[0] }}</span>
                            </div>
                            <div class="mt-3" v-if="singleProcess.manager_id != '0' && singleProcess.transaction_type == '1'">
                                <label for="update-profile-form-6" class="form-label">Select Process</label>
                                <TomSelect v-model="singleProcess.process_id" @change="getSinglePktEmployees(singleProcess.process_id)" :options="{
                          placeholder: 'Select Process'
                        }" class="w-60">
                                    <option value="0">Select Process</option>
                                    <option v-for="(process,ind) in pagedata.singleprocess" :key="ind" :value="process.id">{{ process.process_name }}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.process_id">{{ pagedata.errors.process_id[0] }}</span>

                            </div>
                            <div class="flex items-center mt-3" v-if="singleProcess.process_id != '0' && singleProcess.transaction_type == '1'">
                                <div class="form-check">
                                    <input class="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-1 ml-3 cursor-pointer" value="0" type="radio" name="singleinternal" id="singleinternal" v-model="singleProcess.eternals">
                                    <label class="form-check-label inline-block text-black text-lg" for="singleinternal">
                                        Internal
                                    </label>
                                </div>
                                <div class="form-check ml-6">
                                    <input class="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-1 ml-3 cursor-pointer" value="1" type="radio" name="singleexternal" id="singleexternal" v-model="singleProcess.eternals">
                                    <label class="form-check-label inline-block text-black text-lg" for="singleexternal">
                                        Enternal
                                    </label>
                                </div>
                            </div>
                            <div class="mt-3" v-if="singleProcess.eternals == '0' && singleProcess.process_id != '0' && singleProcess.transaction_type == '1'">
                                <label for="update-profile-form-6" class="form-label">Select Employee</label>
                                <TomSelect v-model="singleProcess.employee_id" :options="{
                            placeholder: 'Select Employee'
                          }" class="w-60">
                                    <option value="0">Select Employee</option>
                                    <option v-for="(emp,ind) in pagedata.singleemployees" :key="ind" :value="emp.id">{{ emp.first_name + ' ' + emp.last_name}}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.employee_id">{{ pagedata.errors.employee_id[0] }}</span>
                            </div>
                            <div class="mt-3" v-else-if="singleProcess.eternals == '1' && singleProcess.process_id != '0' && singleProcess.transaction_type == '1'">
                                <label for="update-profile-form-6" class="form-label">Select Party</label>
                                <TomSelect v-model="singleProcess.party_id" :options="{
                         placeholder: 'Select Party'
                       }" class="w-60">
                                    <option value="0">Select Party</option>
                                    <option v-for="(party,ind) in pagedata.singleparties" :key="ind" :value="party.id">{{ party.firm_name }}</option>
                                </TomSelect>
                                <span class="text-primary-3 mb-2" v-if="pagedata.errors.party_id">{{ pagedata.errors.party_id[0] }}</span>
                            </div>
                        </div>
                        <button type="button" @click="AssignSingleProcess" :disabled="pagedata.submit" class="btn btn-primary w-24 m-auto mt-5">Submit
                            <LoadingIcon v-if="pagedata.submit" icon="oval" color="white" class="w-4 h-4 ml-2" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END:Single Process Assign Modal -->
    <!-- END: Data List -->
    <div id="add-packet-part-modal" class="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <a data-dismiss="modal" href="javascript:;">
                    <XIcon class="w-8 h-8 text-gray-500" />
                </a>
                <div class="modal-body p-10">
                    <!-- <div id="vertical-form"> -->
                    <div class="flex flex-col justify-between mt-5">
                        <!-- BEGIN: Data List -->
                        <div class="intro-y overflow-auto">
                            <div class="flex items-center">
                                <h2 class="intro-y text-lg font-medium mr-5">Update Params</h2>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="intro-y col-span-12">
                                <!-- BEGIN: Input -->
                                <div class="">
                                    <div id="input" class="py-5">
                                        <div class="preview">
                                            <div>
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div class="">
                                                            <div id="input-group-4">Packet No</div>

                                                            <input id="pos-form-1" v-model="pagedata.comment_form.packet_no" name="kapan" type="text" disabled class="form-control flex-1" placeholder="Kapan No" />
                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                      <div class="">
                                                            <div id="input-group-4">Stock No</div>

                                                            <input id="pos-form-1" v-model="pagedata.comment_form.vepari_no" name="stock" type="text" class="form-control flex-1" placeholder="Kapan No" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3">
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div>

                                                            <div class="">
                                                                <div id="input-group-3">Purchase Weight(Ct)</div>
                                                                <input type="text" class="form-control" name="piece" disabled v-model="pagedata.comment_form.weight" @input="$h.preventInvalidInput" aria-describedby="input-group-3" />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                      <div>

                                                        <div class="">
                                                            <div id="input-group-3">New Weight(Ct)</div>
                                                            <input type="text" class="form-control" name="new_weight" v-model="pagedata.comment_form.new_weight" @input="$h.preventInvalidInput" aria-describedby="input-group-3" />
                                                        </div>

                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3" v-if="pagedata.purchase_item.type == 'rough'">
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div>

                                                            <div class="">
                                                                <div id="input-group-3">Length</div>
                                                                <input type="text" class="form-control" name="length"  v-model="pagedata.comment_form.length" aria-describedby="input-group-4" @input="$h.preventInvalidInput" />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                        <div class="">
                                                            <div id="input-group-4">Width</div>
                                                            <input type="text" class="form-control" name="width" v-model="pagedata.comment_form.width" aria-describedby="input-group-4" @input="$h.preventInvalidInput" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3" v-if="pagedata.purchase_item.type == 'rough'">
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div>

                                                            <div class="">
                                                                <div id="input-group-3">Height</div>
                                                                <input type="text" class="form-control" name="length"  v-model="pagedata.comment_form.height" aria-describedby="input-group-4" @input="$h.preventInvalidInput" />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                      <div class="">
                                                            <div id="input-group-4">Comment</div>
                                                            <input type="text" class="form-control" name="new comment" v-model="pagedata.comment_form.comment" aria-describedby="input-group-4" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3" v-if="pagedata.purchase_item.type == 'makeable'">
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div>

                                                            <div class="">
                                                                <div id="input-group-3">Shape</div>
                                                                <select class="form-select" v-model="pagedata.comment_form.shape" aria-label="Default select example">
                                                                    <option v-for="(item,index) in stone_parameters.shapes" :key="item.id" :value="item.id">{{item.shape_name}}</option>
                                                                </select>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                        <div class="">
                                                            <div id="input-group-4">Color</div>
                                                            <select class="form-select" v-model="pagedata.comment_form.color" aria-label="Default select example">
                                                                    <option v-for="(item,index) in stone_parameters.colors" :key="item.id" :value="item.id">{{item.color_name}}</option>
                                                                </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3" v-if="pagedata.purchase_item.type == 'makeable'">
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div>

                                                            <div class="">
                                                                <div id="input-group-3">Purity</div>
                                                                <select class="form-select" v-model="pagedata.comment_form.purity" aria-label="Default select example">
                                                                    <option v-for="(item,index) in stone_parameters.purities" :key="item.id" :value="item.id">{{item.purity_name}}</option>
                                                                </select>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                        <div class="">
                                                            <div id="input-group-4">Cut</div>
                                                            <select class="form-select" v-model="pagedata.comment_form.cut" aria-label="Default select example">
                                                                    <option v-for="(item,index) in stone_parameters.cuts" :key="item.id" :value="item.id">{{item.cut_name}}</option>
                                                                </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3" v-if="pagedata.purchase_item.type == 'makeable'">
                                                <div class="sm:grid grid-cols-2 gap-2">
                                                    <div>
                                                        <div>

                                                            <div class="">
                                                                <div id="input-group-3">Polish</div>
                                                                <select class="form-select" v-model="pagedata.comment_form.polish" aria-label="Default select example">
                                                                    <option v-for="(item,index) in stone_parameters.polish" :key="item.id" :value="item.id">{{item.polish_name}}</option>
                                                                </select>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="mt-2 sm:mt-0">
                                                        <div class="">
                                                            <div id="input-group-4">Symmetry</div>
                                                            <select class="form-select" v-model="pagedata.comment_form.symmetry" aria-label="Default select example">
                                                                    <option v-for="(item,index) in stone_parameters.symmetry" :key="item.id" :value="item.id">{{item.symmetry_name}}</option>
                                                                </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3">
                                                <!-- <label class="form-label">Stone && Est Value</label> -->
                                                <div class="w-full">
                                                    <!-- <div>

                                                        <div class="">

                                                        </div>
                                                    </div> -->
                                                    <div class="flex items-center justify-end">

                                                      <div>
                                                          <div class="mt-2 sm:mt-0">
                                                              <div class="flex justify-end items-center mt-5">
                                                                  <button type="button" :disabled="pagedata.comment_form.loading == true" class="btn btn-secondary w-24 m-auto mr-3 btn-sm" data-dismiss="modal" href="javascript:;">Cancel</button>
                                                                  <button type="button" @click="AddComment" :disabled="pagedata.comment_form.loading == true" class="btn whitespace-nowrap btn-primary btn-sm w-28 m-auto"> Update
                                                                      <LogInIcon v-if="pagedata.comment_form.loading == false" class="h-4 w-4 ml-2 -mt-1" />
                                                                      <LoadingIcon v-if="pagedata.comment_form.loading == true" icon="oval" color="white" class="w-4 h-4 ml-2" /></button>
                                                              </div>
                                                          </div>
                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- END: Input -->
                            </div>
                        </div>
                        <!-- END: Data List -->
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- BEGIN: Single Process Assign Modal -->
     <BarcodeSingleStone ref="BarcodeSingleStoneRef" />
</div>
</template>

<script setup>
/* eslint-disable */
import {
    BASE_URL
} from '@/constants/config'
import axios from 'axios'
import Toastify from 'toastify-js'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import BarcodeSingleStone from '@/components/barcodes/Main.vue'
import {
    computed,
    inject,
    onMounted,
    reactive,
    ref
} from 'vue'
import {
    useStore
} from '@/store'

      const BarcodeSingleStoneRef = ref()
      const store = useStore()
      const tableRef = ref()
      const tabulator = ref()
      const swal = inject('$swal')
      const user_details = computed(() => store.state.user.currentUser)

      const pagedata = reactive({
          access: false,
          errors: [],
          lat_no: '',
          serach: '',
          type: '',
          cancelId: '',
          party: '',
          partyproc: [],
          purchases: [],
          packets: [],
          purchase_item: [],
          managers: [],
          employees: [],
          multipleprocess: [],
          multipleemployees: [],
          multipleparties: [],
          singleprocess: [],
          singleemployees: [],
          singleparties: [],
          processes: [],
          externals: [],
          mulerrors: {
              manager: [],
              process: [],
              employee: []
          },
          submit: false,
          parties: [],
          stones: [],
          message: '',
          error: '',

          comment_form: {
            packet_no: '',
            vepari_no: '',
            packet_id: '',
            comment: '',
            length: '',
            height: '',
            width: '',
            weight: '',
            shape: '',
            color: '',
            purity: '',
            cut: '',
            polish: '',
            symmetry: '',
            new_weight: '',
            loading: false
          }
      })

        const stone_parameters = reactive({
          colors: [],
          cuts: [],
          purities: [],
          polish: [],
          shapes: [],
          symmetry: [],
          fluerocents: [],
          tensions: [],
          stones: [],
          labs: []
        })

        const process = reactive({
            id: '',
            eternals: '0',
            number: '',
            process_id: '0',
            employee_id: '0',
            manager_id: '0',
            party_id: '0',
            transaction_type: '0',
            type: ''
        })
        const singleProcess = reactive({
            id: '',
            eternals: '0',
            number: '',
            process_id: '0',
            employee_id: '0',
            manager_id: '0',
            party_id: '0',
            transaction_type: '0',
            type: ''
        })
        const filters = reactive({
            purchase_type: '0',
            type: 'select',
            party: '0',
            stone_id: '0',
            kapan_no: ''
        })

        const print_single_stone = (item) => {
            // console.log(item.planner_shortcode)
            let data = [];
            
          BarcodeSingleStoneRef.value.setPrintData({id: item.id,                
                owner_value: item.owner_value,
                owner_per_ct: item.owner_per_ct,
                vepari_no: item.vepari_no,
                number: item.number,
                pieces: item.pieces,
                type: item.type,
                stock_type: item.stock_type,
                mk_weight: item.mk_weight,
                cr_weight: item.cr_weight,
                weight: item.weight,
                polish_weight: item.polish_weight,
                barnum: item.barnum,
                shape: item.shape_name,
                color: item.color_name,
                shape_code: item.shape_code,
                color_code: item.color_code,
                purity: item.purity_name,
                cut: item.cut_name,
                polish: item.polish_name,
                symmetry: item.symmetry_name,
                fluerocent: item.fluerocent_name,
                tension: item.tension_name,
                stone: item.stone,
                length: item.length,
                width: item.width,
                height: item.height,
                // date: item.created_at,                
                in_date: item.in_date,
                exp_out_date: item.exp_out_date,
                mkb_date: item.mkb_date,
                planner_shortcode: item.planner_shortcode,
                main_part_vepari_no: item.main_part_vepari_no,
            })
        }
        const print_multi_stone = (items) => {
          let data = [];

          items.forEach(element => {
            data.push({
            id: element.id,
            owner_value: element.owner_value,
            owner_per_ct: element.owner_per_ct,
            vepari_no: element.vepari_no,
            number: element.number,
            pieces: element.pieces,
            type: element.type,
            stock_type: element.stock_type,
            mk_weight: element.mk_weight,
            cr_weight: element.cr_weight,
            weight: element.weight,
            polish_weight: element.polish_weight,
            barnum: element.barnum,
            shape: element.shape_name,
            color: element.color_name,
            shape_code: element.shape_code,
            color_code: element.color_code,
            purity: element.purity_name,
            cut: element.cut_name,
            polish: element.polish_name,
            symmetry: element.symmetry_name,
            fluerocent: element.fluerocent_name,
            tension: element.tension_name,
            stone: element.stone,
            length: element.length,
            width: element.width,
            height: element.height,
            // date: element.created_at,
            in_date: element.in_date,
            exp_out_date: element.exp_out_date,
            mkb_date: element.mkb_date,
            planner_shortcode: element.planner_shortcode,
            main_part_vepari_no: element.main_part_vepari_no,
          })
          });
          BarcodeSingleStoneRef.value.setPrintAllData(data)
        }
        const initTabulator = () => {
            tabulator.value = new Tabulator(tableRef.value, {
                ajaxURL: BASE_URL + 'api/purchase/get_purchase_details',
                ajaxConfig: {
                    method: "GET", //set request type to Position
                    headers: {
                        "Content-type": 'application/json; charset=utf-8', //set specific content type
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                },
                ajaxParams: {
                    purchase_type: filters.purchase_type == '0' ? '' : window.btoa(filters.purchase_type),
                    kapan_no: filters.kapan_no == '' ? '' : window.btoa(filters.kapan_no),
                    party: filters.party == '0' ? '' : window.btoa(filters.party),
                    stone_id: filters.stone_id == '0' ? '' : window.btoa(filters.stone_id),
                    type: filters.type == 'select' ? '' : window.btoa(filters.type)
                },
                ajaxFiltering: true,
                ajaxSorting: true,
                printAsHtml: true,
                printStyled: true,
                headerSort: false,
                pagination: 'remote',
                paginationSize: 20,
                paginationSizeSelector: [20, 30, 40],
                layout: 'fitColumns',
                responsiveLayout: 'collapse',
                placeholder: 'No matching records found',
                columns: [{
                        formatter: 'responsiveCollapse',
                        width: 40,
                        minWidth: 30,
                        hozAlign: 'center',
                        resizable: false,
                        headerSort: false
                    },

                    // For HTML table
                    {
                        title: 'Lot No',
                        responsive: 0,
                        minWidth: 70,
                        field: 'lot_no',
                        //  vertAlign: 'middle',
                        //  hozAlign: 'center',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().lot_no
                 }</div>
               </div>`)
                            cash(a).on('click', function () {
                                Packet(cell.getData());
                            })
                            return a[0]
                        }
                    },
                    {
                        title: 'Kapan',
                        field: 'voucher_no',
                        responsive: 0,
                        minWidth: 100,
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().voucher_no != null ? cell.getData().voucher_no : '-'
                 }</div>
               </div>`)
                            cash(a).on('click', function () {
                              Packet(cell.getData());
                            })
                            return a[0]
                        }
                    },
                    {
                        title: 'Type',
                        responsive: 0,
                        minWidth: 70,
                        field: 'type',
                        vertAlign: 'middle',
                        hozAlign: 'center',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().type
                 }</div>
               </div>`)
                            return a[0]
                        }
                    },
                    {
                        title: 'Party',
                        responsive: 0,
                        minWidth: 100,
                        field: 'firm_name',
                        hozAlign: 'center',
                        vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {

                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().firm_name
                 }</div>
               </div>`)
                            return a[0]
                        }
                    },
                    {
                        title: 'Duration',
                        responsive: 0,
                        minWidth: 100,
                        hozAlign: 'center',
                        vertAlign: 'middle',
                        field: 'due',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().due
                 }</div>
               </div>`)
                            return a[0]
                        }
                    },
                    {
                        title: 'Pcs',
                        field: 'pieces',
                        minWidth: 50,
                        //  hozAlign: 'center',
                        //  vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().pieces
                 }</div>
               </div>`)
                            return a[0]
                        }
                    },
                    {
                        title: 'Total Wt',
                        responsive: 0,
                        minWidth: 100,
                        hozAlign: 'center',
                        vertAlign: 'middle',
                        field: 'total_weight',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().total_weight
                 }</div>
               </div>`)
                            return a[0]
                        }
                    },

                    {
                        title: 'Stone',
                        field: 'stone_name',
                        minWidth: 50,
                        //  hozAlign: 'center',
                        //  vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                 <div class="whitespace-nowrap">${
                   cell.getData().stone_name
                 }</div>
               </div>`)
                            return a[0]
                        }
                    },
                    {
                        title: 'Est Majuri',
                        field: 'est_value',
                        minWidth: 50,
                        //  hozAlign: 'center',
                        //  vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                            const a = cash(`<div class="w-full m-0">
                                <div class="whitespace-nowrap">${
                                  cell.getData().est_value ? cell.getData().est_value : '-'
                                }</div>
                              </div>`)
                            return a[0]
                        }
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        responsive: 0,
                        hozAlign: 'left',
                        vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                          // if(user_details.value.user_role == 3) {

                          // } else {

                            const a = cash(`<div class="w-full m-0">
                                <div class="whitespace-nowrap">${
                                  cell.getData().status == 2 ? '<p class="text-primary-1">In Process</p>': cell.getData().status == 1 ? '<p class="text-primary-8">Active</p>' : cell.getData().status == 0 ? '<p class="text-primary-6">Hold</p>' : cell.getData().status == 3 ? '<p class="text-primary-3">Cancelled</p>' : '<p class="text-primary-4">Delevierd</p>'
                                }</div>
                              </div>`)
                            return a[0]
                          // }
                        }
                    },
                    {
                        title: 'Create IP',
                        responsive: 0,
                        minWidth: 100,
                        hozAlign: 'center',
                        vertAlign: 'middle',
                        field: 'issue_trans_ip',
                        print: false,
                        download: false,
                        formatter(cell) {
                            return cell.getData().issue_trans_ip
                        }
                    },
                    {
                        hozAlign: 'center',
                        field: 'status',
                        width: 10,
                        vertAlign: 'middle',
                        print: false,
                        download: false,
                        formatter(cell) {
                          if(user_details.value.user_role == 3) {

                          } else {

                            const a = cash(`<div class="w-full m-0">
                                <div class="whitespace-nowrap">${
                                  cell.getData().status == 0 && user_details.value.account_id == cell.getData().manager_id ? '<button class="flex items-center text-theme-1"> A </button>' : cell.getData().status == 1 && user_details.value.account_id == cell.getData().manager_id ? '<button class="flex items-center text-theme-9"><i data-feather="chevrons-right" class="w-4 h-4"></i></button>' : ''
                                }</div>
                              </div>`)
                            cash(a).on('click', function () {
                                if (cell.getData().status == 0 && user_details.value.account_id == cell.getData().manager_id) {
                                    AcceptAll(cell.getData().id)
                                } else if (cell.getData().status == 1 && user_details.value.account_id == cell.getData().manager_id) {
                                    cash('#superlarge-modal-size-preview2').modal('show')
                                    ProcessAssign(cell.getData().id, cell.getData().lot_no, cell.getData().type)
                                }
                            })
                            return a[0]
                          }
                        }
                    }
                ],
                renderComplete() {
                    feather.replace({
                        'stroke-width': 1.5
                    })
                }
            })
        }

        function Packet(purchase) {
            pagedata.purchase_item = purchase
            pagedata.packets = []
            const params = {
                id: window.btoa(purchase.id)
            }
            axios({
                url: 'api/purchase/get_purchase_packets',
                method: 'post',
                baseURL: BASE_URL,
                data: params,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                pagedata.packets = res.data.items
            });
        }

        function DeletePurchase(id) {
            swal({
            title: "Are you sure?",
            text: "You are about to cancel purchase!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
            showLoaderOnConfirm: true,
            cancelButtonText: "Cancel",

            allowOutsideClick: () => !swal.isLoading()
          }).then(result => {
            if (result.isConfirmed) {
              const params = {
                  id: window.btoa(id),
                  ip: localStorage.getItem('sk_key')
              }
              axios({
                  url: 'api/purchase/reject_purchase',
                  method: 'post',
                  baseURL: BASE_URL,
                  data: params,
                  headers: {
                      Authorization: 'Bearer ' + localStorage.getItem('token')
                  },
                  config: {
                      headers: {
                          'Accept': 'application/json'
                      }
                  }
              }).then(() => {
                  initTabulator()
                  if (pagedata.packets.length > 0) {
                      Packet(pagedata.purchase_item)
                  }
              })
            }
          });
        }

        function ProcessAssign(id, lot, type) {
            Packet(pagedata.purchase_item)
            process.type = type
            pagedata.lat_no = lot
            process.id = id
            getAllManager()
        }

        function SinglePacketAssign(id, no, type) {
            singleProcess.number = no
            singleProcess.id = id
            singleProcess.type = type
            getAllManager()
        }

        function getAllManager() {
            axios({
                url: 'api/master/dp_managers',
                method: 'post',
                baseURL: BASE_URL,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                pagedata.managers = res.data.items

                //  var i = pagedata.managers.length;
                //   while (i--) {
                //       if (pagedata.managers[i]['id'] == user_details.value.account_id) {
                //           pagedata.managers.splice(i, 1);
                //       }
                //   }
                process.manager_id = '0'
            })
        }

        function getSinglePktEmployees(id) {
            const params = {
                manager_id: window.btoa(singleProcess.manager_id),
                process_id: window.btoa(id),
                process_type: window.btoa(singleProcess.type),
            }
            if (id != '0' && singleProcess.manager_id != '0') {

                axios({
                    url: 'api/master/get_employees_by_manager_process',
                    method: 'post',
                    baseURL: BASE_URL,
                    data: params,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    },
                    config: {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }
                }).then((res) => {
                    pagedata.singleemployees = res.data.items
                    singleProcess.employee_id = '0'
                })
                axios({
                    url: 'api/master/get_jober_details_by_process',
                    method: 'post',
                    baseURL: BASE_URL,
                    data: params,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    },
                    config: {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }
                }).then((res) => {
                    pagedata.singleparties = res.data.items
                    singleProcess.party_id = '0'
                })
            } else {
                pagedata.singleemployees = []
                pagedata.singleparties = []
                singleProcess.party_id = '0'
                singleProcess.employee_id = '0'
            }
        }

        function getMultiplePktEmployees(id) {
            const params = {
                manager_id: window.btoa(process.manager_id),
                process_id: window.btoa(id),
                process_type: window.btoa(process.type),
            }
            if (id != '0' && process.manager_id != '0') {

                axios({
                    url: 'api/master/get_employees_by_manager_process',
                    method: 'post',
                    baseURL: BASE_URL,
                    data: params,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    },
                    config: {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }
                }).then((res) => {
                    pagedata.multipleemployees = res.data.items
                    process.employee_id = '0'
                })
                axios({
                    url: 'api/master/get_jober_details_by_process',
                    method: 'post',
                    baseURL: BASE_URL,
                    data: params,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    },
                    config: {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }
                }).then((res) => {
                    pagedata.multipleparties = res.data.items
                    process.party_id = '0'
                })
            } else {
                pagedata.multipleemployees = []
                pagedata.multipleparties = []
                process.party_id = '0'
                process.employee_id = '0'
            }
        }

        function getParties() {
            axios({
                url: 'api/master/dp_parties',
                method: 'post',
                baseURL: BASE_URL,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                pagedata.parties = res.data.items
            })
        }

        function getStones() {
            axios({
                url: 'api/master/dp_stone',
                method: 'post',
                baseURL: BASE_URL,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                pagedata.stones = res.data.items
            })
        }

        function getSingleProcessData(id) {
            if (id != 0) {
                const params = {
                    user_id: id,
                    process_type: window.btoa(singleProcess.type)
                }
                if (id != '0') {
                    axios({
                        url: 'api/master/manager_processes',
                        method: 'post',
                        baseURL: BASE_URL,
                        data: params,
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('token')
                        },
                        config: {
                            headers: {
                                'Accept': 'application/json'
                            }
                        }
                    }).then((res) => {
                        pagedata.singleprocess = res.data.items
                        singleProcess.process_id = '0'
                    })
                } else {
                    pagedata.singleprocess = []
                    singleProcess.process_id = '0'
                }
            }
        }

        function getMultipleProcessData(id) {
            if (id != 0) {
                const params = {
                    user_id: id,
                    process_type: window.btoa(process.type)
                }
                if (id != '0') {
                    axios({
                        url: 'api/master/manager_processes',
                        method: 'post',
                        baseURL: BASE_URL,
                        data: params,
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('token')
                        },
                        config: {
                            headers: {
                                'Accept': 'application/json'
                            }
                        }
                    }).then((res) => {
                        pagedata.multipleprocess = res.data.items
                        process.process_id = '0'
                    })
                } else {
                    pagedata.multipleprocess = []
                    process.process_id = '0'
                }
            }
        }

        function AssignProcess() {
            const params = {
                id: window.btoa(process.id),
                externals: window.btoa(process.eternals),
                number: window.btoa(process.number),
                process_id: process.process_id == '0' ? '' : window.btoa(process.process_id),
                employee_id: process.employee_id == '0' ? '' : window.btoa(process.employee_id),
                manager_id: process.manager_id == '0' ? '' : window.btoa(process.manager_id),
                party_id: process.party_id == '0' ? '' : window.btoa(process.party_id),
                transaction_type: window.btoa(process.transaction_type),
            }
            pagedata.submit = true
            let validate = true
            if (validate == true) {
                axios({
                    url: 'api/process/admin_multiple_issue',
                    method: 'post',
                    baseURL: BASE_URL,
                    data: params,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    },
                    config: {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }
                }).then((res) => {
                    pagedata.submit = false
                    initTabulator()
                    if (pagedata.packets.length > 0) {
                        Packet(pagedata.purchase_item)
                    }
                    setTimeout(() => {
                        pagedata.multipleemployees = []
                        pagedata.multipleparties = []
                        pagedata.multipleprocess = []
                        process.party_id = '0'
                        process.process_id = '0'
                        process.manager_id = '0'
                        process.employee_id = '0'
                        process.id = 0
                        process.eternals = '0'
                    }, 100);
                    pagedata.message = res.data.success
                    setTimeout(() => {
                        basicNonStickyNotificationPacketSuccess()
                    }, 30);
                    setTimeout(() => {
                        pagedata.message = ''
                    }, 3000);
                    cash('#superlarge-modal-size-preview2').modal('hide')
                }).catch((err) => {
                    pagedata.submit = false
                    console.warn(err.response.data.error)
                    if (err.response.data.error) {
                        swal("Warning!", err.response.data.error, "warning")
                    } else {
                        pagedata.errors = err.response.data.errors
                        setTimeout(() => {
                            pagedata.errors = []
                        }, 3000);
                    }
                })
            } else {
                pagedata.submit = false
            }
        }
        function AddStoneDetails(packet) {

          pagedata.comment_form.packet_no = packet.number
          pagedata.comment_form.vepari_no = packet.vepari_no
          pagedata.comment_form.packet_id = packet.id
          pagedata.comment_form.weight = packet.cr_weight
          pagedata.comment_form.shape = packet.shape
          pagedata.comment_form.color = packet.color
          pagedata.comment_form.purity = packet.purity
          pagedata.comment_form.cut = packet.cut
          pagedata.comment_form.polish = packet.polish
          pagedata.comment_form.symmetry = packet.symmetry
          pagedata.comment_form.new_weight = ""
          pagedata.comment_form.comment = (packet.comment ? packet.comment : '')
          pagedata.comment_form.height = (packet.height ? packet.height : '')
          pagedata.comment_form.width = (packet.width ? packet.width : '')
          pagedata.comment_form.length = (packet.length ? packet.length : '')
        }
        function AddComment() {
            const params = {
                id: window.btoa(pagedata.comment_form.packet_id),
                comment: window.btoa(pagedata.comment_form.comment),
                height: window.btoa(pagedata.comment_form.height),
                width: window.btoa(pagedata.comment_form.width),
                length: window.btoa(pagedata.comment_form.length),
                shape: window.btoa(pagedata.comment_form.shape),
                color: window.btoa(pagedata.comment_form.color),
                purity: window.btoa(pagedata.comment_form.purity),
                cut: window.btoa(pagedata.comment_form.cut),
                polish: window.btoa(pagedata.comment_form.polish),
                symmetry: window.btoa(pagedata.comment_form.symmetry),
                vepari_no: window.btoa(pagedata.comment_form.vepari_no),
                new_weight: window.btoa(pagedata.comment_form.new_weight),
                ip: localStorage.getItem('sk_key')
            }

            let promise_url = 'api/purchase/addComment'
            pagedata.comment_form.loading = true

            let promise = axios({
                url: promise_url,
                method: "POST",
                data: params,
                baseURL: BASE_URL,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),

                },
                config: {
                    headers: {
                        Accept: "application/json"
                    }
                }
            });
            return promise
                .then(result => result.data)
                .then(data => {

                    if (data.status == 'error') {
                      pagedata.comment_form.loading = false
                      if(data.type && data.type == 'warning') {
                        AddCommentConfirm(data.message);
                      } else {
                        swal('Warning', data.message, 'warning');
                      }
                    } else {
                        swal('Success', data.message, 'success');

                        pagedata.comment_form.packet_no = ''
                        pagedata.comment_form.vepari_no = ''
                        pagedata.comment_form.packet_id = ''
                        pagedata.comment_form.weight = ''
                        pagedata.comment_form.new_weight = ''
                        pagedata.comment_form.height = ''
                        pagedata.comment_form.shape = ''
                        pagedata.comment_form.color = ''
                        pagedata.comment_form.purity = ''
                        pagedata.comment_form.cut = ''
                        pagedata.comment_form.polish = ''
                        pagedata.comment_form.symmetry = ''
                        pagedata.comment_form.width = ''
                        pagedata.comment_form.length = ''
                        pagedata.comment_form.comment = ''
                        pagedata.comment_form.vepari_no = ''
                        pagedata.comment_form.loading = false

                        cash('#add-packet-part-modal').modal('hide')
                        Packet(pagedata.purchase_item)
                    }
                })
                .catch(_error => {
                  pagedata.loading = false
                    swal('Error', 'Something went wrong.', 'error');
                });
        }
        function AddCommentConfirm(mfg) {
          swal({
                  title: "Are you sure?",
                  text: mfg,
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Confirm",
                  showLoaderOnConfirm: true,
                  cancelButtonText: "Cancel",

                  allowOutsideClick: () => !$Swal.isLoading()
              }).then(result => {
                if (result.isConfirmed) {
                  const params = {
                    id: window.btoa(pagedata.comment_form.packet_id),
                    comment: window.btoa(pagedata.comment_form.comment),
                    height: window.btoa(pagedata.comment_form.height),
                    width: window.btoa(pagedata.comment_form.width),
                    length: window.btoa(pagedata.comment_form.length),
                    shape: window.btoa(pagedata.comment_form.shape),
                    color: window.btoa(pagedata.comment_form.color),
                    purity: window.btoa(pagedata.comment_form.purity),
                    cut: window.btoa(pagedata.comment_form.cut),
                    polish: window.btoa(pagedata.comment_form.polish),
                    symmetry: window.btoa(pagedata.comment_form.symmetry),
                    vepari_no: window.btoa(pagedata.comment_form.vepari_no),
                    new_weight: window.btoa(pagedata.comment_form.new_weight),
                }

                let promise_url = 'api/purchase/addCommentConfirm'
                pagedata.comment_form.loading = true

                let promise = axios({
                    url: promise_url,
                    method: "POST",
                    data: params,
                    baseURL: BASE_URL,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),

                    },
                    config: {
                        headers: {
                            Accept: "application/json"
                        }
                    }
                });
                return promise
                    .then(result => result.data)
                    .then(data => {

                        if (data.status == 'error') {
                            swal('Warning', data.message, 'warning');
                            pagedata.comment_form.loading = false
                        } else {
                            swal('Success', data.message, 'success');

                            pagedata.comment_form.packet_no = ''
                            pagedata.comment_form.vepari_no = ''
                            pagedata.comment_form.packet_id = ''
                            pagedata.comment_form.weight = ''
                            pagedata.comment_form.new_weight = ''
                            pagedata.comment_form.height = ''
                            pagedata.comment_form.shape = ''
                            pagedata.comment_form.color = ''
                            pagedata.comment_form.purity = ''
                            pagedata.comment_form.cut = ''
                            pagedata.comment_form.polish = ''
                            pagedata.comment_form.symmetry = ''
                            pagedata.comment_form.width = ''
                            pagedata.comment_form.length = ''
                            pagedata.comment_form.vepari_no = ''
                            pagedata.comment_form.comment = ''
                            pagedata.comment_form.loading = false

                            cash('#add-packet-part-modal').modal('hide')
                            Packet(pagedata.purchase_item)
                        }
                    })
                    .catch(_error => {
                      pagedata.loading = false
                        swal('Error', 'Something went wrong.', 'error');
                    });

                }
              });
            }

        function AssignSingleProcess() {
            const params = {
                id: window.btoa(singleProcess.id),
                externals: window.btoa(singleProcess.eternals),
                number: window.btoa(singleProcess.number),
                process_id: singleProcess.process_id == '0' ? '' : window.btoa(singleProcess.process_id),
                employee_id: singleProcess.employee_id == '0' ? '' : window.btoa(singleProcess.employee_id),
                manager_id: singleProcess.manager_id == '0' ? '' : window.btoa(singleProcess.manager_id),
                party_id: singleProcess.party_id == '0' ? '' : window.btoa(singleProcess.party_id),
                transaction_type: window.btoa(singleProcess.transaction_type),
                ip: localStorage.getItem('sk_key')
            }
            pagedata.submit = true
            axios({
                url: `api/process/admin_single_issue`,
                method: 'post',
                baseURL: BASE_URL,
                data: params,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                pagedata.submit = false
                initTabulator()
                if (pagedata.packets.length > 0) {
                    Packet(pagedata.purchase_item)
                }
                setTimeout(() => {
                    pagedata.employees = []
                    pagedata.processes = []
                    pagedata.singleparties = []
                    singleProcess.number = ''
                    singleProcess.manager_id = '0'
                    singleProcess.party_id = '0'
                    singleProcess.employee_id = '0'
                    singleProcess.process_id = '0'
                    singleProcess.id = 0
                    singleProcess.eternals = '0'
                }, 100);

                pagedata.message = res.data.success
                setTimeout(() => {
                    basicNonStickyNotificationPacketSuccess()
                }, 30);
                setTimeout(() => {
                    pagedata.message = ''
                }, 3000);
                // basicNonStickyNotificationPacketAssign()
                cash('#single-process-modal').modal('hide')
            }).catch((err) => {
                pagedata.submit = false
                if (err.response.data.error) {
                    swal("Warning!", err.response.data.error, "warning")
                } else {
                    pagedata.errors = err.response.data.errors
                    setTimeout(() => {
                        pagedata.errors = []
                    }, 3000);
                }
            })
        }

        function DeletePacket(id) {

          swal({
            title: "Are you sure?",
            text: "You are about to cancel packet!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
            showLoaderOnConfirm: true,
            cancelButtonText: "Cancel",

            allowOutsideClick: () => !swal.isLoading()
          }).then(result => {
            if (result.isConfirmed) {
              const params = {
                  id: window.btoa(id),
                  ip: localStorage.getItem('sk_key')
              }
              axios({
                  url: 'api/purchase/reject_packet',
                  method: 'post',
                  baseURL: BASE_URL,
                  data: params,
                  headers: {
                      Authorization: 'Bearer ' + localStorage.getItem('token')
                  },
                  config: {
                      headers: {
                          'Accept': 'application/json'
                      }
                  }
              }).then((res) => {

                  if (res.data.status == 'error') {
                      swal("Warning!", res.data.message, "warning");
                      return;
                  } else {
                      initTabulator()
                      if (pagedata.packets.length > 0) {
                          Packet(pagedata.purchase_item)
                      }

                  }
              })
            }
          });
        }

        function validateManagerId(id) {
            if (user_details.value.account_id == process.manager_id && process.transaction_type == "0") {
                process.manager_id = '0'
                swal("Warning!", "Self Transfer is Not Allowed !", "warning");
            }
            getMultipleProcessData(id)
        }

        function singlevalidateManagerId(id) {
            if (user_details.value.account_id == singleProcess.manager_id && singleProcess.transaction_type == "0") {
                singleProcess.manager_id = '0'
                swal("Warning!", "Self Transfer is Not Allowed !", "warning");
            }
            getSingleProcessData(id)
        }
        const basicNonStickyNotificationPacketSuccess = () => {
            Toastify({
                node: cash('#basic-non-sticky-notification-packet-success')
                    .clone()
                    .removeClass('hidden')[0],
                duration: 5000,
                newWindow: true,
                close: true,
                gravity: 'top',
                position: 'right',
                stopOnFocus: true
            }).showToast()
        }

        function AddToStock(id) {
            const params = {
                id: window.btoa(id),
                ip: localStorage.getItem('sk_key')
            }
            axios({
                url: 'api/purchase/accept_packet',
                method: 'post',
                baseURL: BASE_URL,
                data: params,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                initTabulator()
                if (pagedata.packets.length > 0) {

                    Packet(pagedata.purchase_item)

                }
            })
        }

        function AcceptAll(id) {
            axios({
                url: 'api/purchase/accept_purchase',
                method: 'post',
                baseURL: BASE_URL,
                data: { id: window.btoa(id), ip: localStorage.getItem('sk_key') },
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                initTabulator()
                if (pagedata.packets.length > 0) {
                    Packet(pagedata.purchase_item)
                }
            }).catch(() => {

            })
        }

        function get_all_parameters() {
            axios({
                url: 'api/master/get_all_parameters',
                method: 'post',
                baseURL: BASE_URL,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                },
                config: {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            }).then((res) => {
                stone_parameters.colors = res.data.color
                stone_parameters.cuts = res.data.cut
                stone_parameters.purities = res.data.purity
                stone_parameters.polish = res.data.polish
                stone_parameters.shapes = res.data.shape
                stone_parameters.symmetry = res.data.symmetry
                stone_parameters.fluerocents = res.data.fluerocent
                stone_parameters.tensions = res.data.tension
                stone_parameters.stones = res.data.stone
                stone_parameters.labs = res.data.lab
            })
        }

        // Reset Filters
        const onResetFilter = () => {
            filters.purchase_type = '0'
            filters.type = 'select'
            filters.party = '0'
            filters.stone_id = '0'
            filters.kapan_no = ''
        }

        onMounted(() => {
            initTabulator()
            get_all_parameters()
            getParties()
            getStones()
        })
</script>
